import React from 'react';

export function LoadingScreen({ theme }) {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: 18,
      background: theme?.bg || '#0F0E0D',
      color: theme?.textMuted || '#A19B8F',
    }}>
      <style>{`
        @keyframes tt-pulse-coral {
          0%, 100% { opacity: 1; transform: translateY(0); }
          50% { opacity: 0.55; transform: translateY(-3px); }
        }
        @keyframes tt-pulse-gold {
          0%, 100% { opacity: 1; transform: translateY(0); }
          50% { opacity: 0.55; transform: translateY(-3px); }
        }
        .tt-logo-coral { animation: tt-pulse-coral 1.4s ease-in-out infinite; }
        .tt-logo-gold { animation: tt-pulse-gold 1.4s ease-in-out infinite; animation-delay: 0.7s; }
      `}</style>

      <svg width="60" height="60" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(60,60)">
          <g className="tt-logo-coral">
            <rect x="-30" y="-20" width="20" height="40" rx="3" fill={theme?.coral || '#FF5A4E'}/>
            <rect x="-36" y="-20" width="32" height="9" rx="3" fill={theme?.coral || '#FF5A4E'}/>
          </g>
          <g className="tt-logo-gold">
            <rect x="6" y="-22" width="20" height="40" rx="3" fill={theme?.gold || '#FFB627'}/>
            <rect x="0" y="-22" width="32" height="9" rx="3" fill={theme?.gold || '#FFB627'}/>
          </g>
        </g>
      </svg>

      <div style={{ fontSize: 13, fontWeight: 500 }}>Get sh*it done · Mindre stress · mere kærlighed</div>
    </div>
  );
}
